import React, { useState } from 'react';
import './Login.css';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://127.0.0.1:5000';

function Login({ onLogin }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleLogin = async () => {
    try {
      setLoading(true);
      setError(null);
      // Direct redirect to backend login endpoint
      window.location.href = `${API_BASE_URL}/api/login`;
    } catch (err) {
      setError('Failed to start login process');
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1>🎵 True Shuffle</h1>
        <p className="login-subtitle">
          Get truly random shuffled playback for your Spotify playlists
        </p>
        
        <div className="login-content">
          <div className="login-icon">
            <svg width="60" height="60" viewBox="0 0 24 24" fill="#1db954">
              <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.84-.179-.84-.66 0-.479.24-.78.721-.84 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.78.061 1.081zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.42 1.56-.299.421-1.02.599-1.559.3z"/>
            </svg>
          </div>
          
          <h2>Connect Your Spotify Account</h2>
          <p>
            To use True Shuffle, login through Spotify.
            This allows the app to access your playlists and control playback.
          </p>
          
          <button 
            onClick={handleLogin}
            disabled={loading}
            className="login-btn"
          >
            {loading ? (
              <>
                <div className="spinner-small"></div>
                Connecting...
              </>
            ) : (
              <>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                  <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.84-.179-.84-.66 0-.479.24-.78.721-.84 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.78.061 1.081zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.42 1.56-.299.421-1.02.599-1.559.3z"/>
                </svg>
                Login with Spotify
              </>
            )}
          </button>
          
          {error && (
            <div className="error-message">
              ❌ {error}
            </div>
          )}
          
          <div className="login-info">
            <h3>What permissions are needed?</h3>
            <ul>
              <li>✅ View your playlists</li>
              <li>✅ Control your Spotify playback</li>
              <li>✅ See your currently playing track</li>
            </ul>
            <p className="privacy-note">
              Your data stays private and is only used for shuffling your playlists.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
